<!--
Menu item

This is mostly straightforward except for Deadlines & Grades item, which has an extra indicator that shows when there are overdue grades

Usage: <MenuItem />
@author ab557z
-->
<template>
  <li class="list-group-item menuLi" v-on:click="go(path, externalpath)">
    <span class="menuItem">
      <font-awesome-icon :icon="icon" size="1x" class="menuIcon"></font-awesome-icon>
      <p style="display:inline-block;margin-left:30px;font-weight:bold;">{{ text }} <GradeCheck v-if="path == '/deadlines'" /></p>
      <font-awesome-icon icon="arrow-right" size="sm" class="menuChev"></font-awesome-icon>
    </span>
  </li>
</template>

<script>
import GradeCheck from '@/components/af/GradeCheck.vue'

export default {
  name: 'MenuItem',
  props: ['icon', 'text', 'path', 'externalpath'],
  components: {
    GradeCheck /* if Deadlines and Grades */
  },
  methods: {
    go (path, ext) {
      if (ext) {
        window.location.href = ext
      } else {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.menuLi {
   border-left:0px !important;
   border-right:0px !important;
   border-top:0px !important;
   border-bottom:2px solid #f2f2f2 !important;
   height: 52px;
}

.menuLi p {
  margin-bottom:0px !important;
  font-size:18px;
  color:#005C8A;
}

.menuItem {
  color:#005C8A;
}

.menuIcon {
  position:absolute;
  margin-top:5px;
}

.menuChev {
  position: absolute;
  right: 10px;
  top: 18px;
}
.list-group-item {
  padding-left:20px;
  padding-right:20px;
  display: flex;
  flex-direction: row;
  align-items:center;
}
</style>
